import { useEffect, useState } from 'react';
import { useLocation } from 'wouter';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import apiService from 'Services/apiService';
import e from './style.module.css';
import segBuild from 'assets/img/segurnetB.svg';
import AlertNotification, {IAlert} from "components/common/AlertNotification/AlertNotification";
import { ModalRecovery } from './Modal/ModalRecovery';

export const Recovery = () => {
  const [, setLocation] = useLocation();
  const token = localStorage.getItem('user');
  const [alert, setAlert] =  useState<IAlert>({ show: false, title: '', details: '', variant: 'Danger' });
  const [loading, setLoading] = useState(false);
  
  useEffect(() => {
    if (token) {
      setLocation('/');
    }
  }, [token, setLocation]);

  const resetAlert = () => {
    setAlert(prev => ({ ...prev, show: false }));
  };
  
  const handleRecovery = (username: string) => {
    setLoading(true);
    apiService({
      name: 'recovery',
      body: { userN: username },
      onSuccess: () => {
        setAlert({
          show: true,
          title: 'Correo enviado con éxito.',
          details: 'Por favor, revise su bandeja de entrada y siga las instrucciones proporcionadas.',
          variant: 'Success'
        });
      },
      onError: (e) => {
        const error = typeof e === 'string' ? e : e.response
        setAlert({
          show: true,
          title: 'Error al enviar el correo de recuperación',
          details: error || 'Por favor intente nuevamente, si el problema persiste contactar a soporte.',
          variant: 'Danger'
        })
      },
      onFinally() {
        setLoading(false);
      }
    });
  };  

  return (
    <>
      <Container className={e.login__ctn}>
        <Row>
          <img
            src={segBuild}
            alt='Vector oficina principal de Segurnet'
            className={`center ${e.login__img}`}
          />
        </Row>
        <ModalRecovery
          onSubmit={handleRecovery}
          disableBtn={loading}
        />
      </Container>
      <AlertNotification
        show={alert?.show}
        title= {alert?.title}
        details= {alert?.details}
        variant={alert?.variant}
        onClose={resetAlert}
      />
    </>
  );
};